import React, { useState } from 'react'
import MobileModal from 'srcReact/components/common2/MobileModal'
import Modal from 'srcReact/components/common2/Modal'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import GroupMixrPill from 'srcReact/components/common2/GroupMixrPill'
import { formatLastUpdateDate, getDateFormat2, getTimeFormat2 } from 'srcReact/helpers/datetimeHelper'
import Divider from 'srcReact/components/common2/Divider'
import EmojisForRating from '../EmojisForRating'
import Button from 'srcReact/components/common2/Button'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

function RateMixrModal({ isOpen, closeModal, handleRateMixr, openWriteReviewModal, isMobileDevice, mixr }) {
  const { t } = useTranslation()
  const [selectedRating, setSelectedRating] = useState(0)
  const [errorMessage, setErrorMessage] = useState('')
  const handleChangeRating = (value) => {
    setErrorMessage('')
    setSelectedRating(value)
    handleRateMixr(value)
  }

  const handleDone = () => {
    if (selectedRating == 0) {
      setErrorMessage(t('rating.requiredRating'))
    } else {
      closeModal()
    }
  }
  const renderContent = () => {
    return (
      <React.Fragment>
        <div className={styles.mixrData}>
          <GroupMixrPill size='medium' type='mixr' picture={mixr.picture.url} />
          <div className={styles.data}>
            <span
              className={styles.datetime}
              dangerouslySetInnerHTML={{
                __html: `<span>${formatLastUpdateDate(mixr.utc_start_at, getDateFormat2())}</span> ${t(
                  'global.at'
                )} ${formatLastUpdateDate(mixr.utc_start_at, getTimeFormat2()).toLowerCase()}`
              }}
            />

            <h1 className={styles.name}>{mixr.name}</h1>
          </div>
        </div>
        <Divider className={styles.divider} />
        <EmojisForRating size='large60' handleRateMixr={handleChangeRating} className={styles.emojisInModal} />
        {errorMessage && <ErrorMessage text={errorMessage} className={styles.error} />}
        <div className={styles.buttons}>
          <Button text={t('global.done')} handleClick={handleDone} size='large' style='secondary' />
          <Button
            text={t('rating.review.writeReview')}
            handleClick={() => {
              if (selectedRating == 0) {
                setErrorMessage(t('rating.requiredRating'))
              } else {
                openWriteReviewModal()
              }
            }}
            size='large'
          />
        </div>
      </React.Fragment>
    )
  }
  return isMobileDevice ? (
    <MobileModal isOpen={isOpen} handleClose={closeModal} title={`${t('rating.rateMixrTitle')}!`}>
      {renderContent()}
    </MobileModal>
  ) : (
    <Modal isOpen={isOpen} handleClose={closeModal} title={`${t('rating.rateMixrTitle')}!`}>
      {renderContent()}
    </Modal>
  )
}

export default RateMixrModal
